//引入接口文档
import req from '@/utils/req.js'

//会诊记录分页查询
export function pageSynergyRecord(params) {
  return req.post("/dsicm-api/feign/synergy-record/page", params);
}

//保存小结
export function saveSynergyConclusion(params) {
  return req.put("/dsicm-api/feign/synergy-record/save-synergy-conclusion", params);
}

//根据会诊ID获取音频播放列表
export function rtcAudioRecord(bizType,bizUnionId) {
  return req.get(`/dsicm-rtc/feign/dsicm-rtc/audio/${bizType}/${bizUnionId}`);
}

//发送会诊小结信息
export function sendSynergyConclusion(params) {
  return req.get("/biz/synergy-record/sendSynergyConclusion", params);
}

// ———————————— 创建会诊页面下拉数据 ————————————
//创建会诊-机构列表
export function fromOrgs(params) {
  return req.get("/biz/synergy-relation/from-orgs", params);
}

//创建会诊-下级医生列表
export function fromDoctors(params) {
  return req.get("/biz/synergy-relation/from-doctors", params);
}

//创建会诊-团队列表
export function toTeams(params) {
  return req.get("/biz/synergy-relation/to-teams", params);
}

//创建会诊-上级医生列表
export function toDoctors(params) {
  return req.get("/biz/synergy-relation/to-doctors", params);
}

//创建会诊-全病程患者列表
export function relationPatients(params) {
  return req.post("/biz/synergy-relation/patients", params);
}


// —————————————— 创建会诊相关接口 ——————————————————
//会诊状态
export function synergyStatus(params) {
  return req.get("/biz/synergy-record/status", params);
}

// //管理端-获取会诊信息
// export function listSynergyInfo(params) {
//   return req.get("/admin/synergy-record/listSynergyInfo", params);
// }

//会诊记录表详情
export function synergyDetail(id) {
  return req.get(`/biz/synergy-record/${id}`);
}

//会诊记录表创建，仅支持控台创建
export function createSynergy(params) {
  return req.post("/biz/synergy-record/create", params,{loading:true});
}

//会诊价格计算
export function computedPrice(params) {
  return req.post("/biz/synergy-record/price", params);
}

//会诊记录表重置，仅支持控台重置
export function resetSynergy(params) {
  return req.post("/biz/synergy-record/reset", params);
}

//会诊记录表更新，仅支持控台更新
export function updateSynergy(params) {
  return req.post("/biz/synergy-record/update", params,{loading:true});
}


